import React from 'react';

interface CertificationDetailTabProps {
  employeeData: any;
}

const formatDate = (dateString: string | null | undefined) => {
  if (!dateString) return '-';
  try {
    const date = new Date(dateString);
    return date.toLocaleDateString('id-ID', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  } catch {
    return dateString;
  }
};

export default function CertificationDetailTab({ employeeData }: CertificationDetailTabProps) {
  const certifications = employeeData.certifications || [];

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-semibold">Sertifikasi & Pelatihan</h3>
        <p className="text-gray-500 text-sm">Daftar sertifikasi dan pelatihan yang dimiliki</p>
      </div>

      {certifications.length === 0 ? (
        <div className="text-center py-8 text-gray-500">
          <p>Tidak ada data sertifikasi</p>
        </div>
      ) : (
        <div className="space-y-4">
          {certifications.map((cert: any, index: number) => (
            <div key={index} className="border-2 rounded-lg p-4 space-y-3 bg-gray-50">
              <h4 className="font-medium text-gray-900">Sertifikasi #{index + 1}</h4>
              <div className="grid md:grid-cols-2 gap-3">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Nama Sertifikasi
                  </label>
                  <div className="px-3 py-2 bg-white border border-gray-200 rounded-md text-gray-900">
                    {cert.name || '-'}
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Kategori</label>
                  <div className="px-3 py-2 bg-white border border-gray-200 rounded-md text-gray-900">
                    {cert.category || '-'}
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Penyelenggara
                  </label>
                  <div className="px-3 py-2 bg-white border border-gray-200 rounded-md text-gray-900">
                    {cert.organizer || '-'}
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    No. Sertifikat
                  </label>
                  <div className="px-3 py-2 bg-white border border-gray-200 rounded-md text-gray-900 font-mono">
                    {cert.certificate_number || '-'}
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Tanggal Terbit
                  </label>
                  <div className="px-3 py-2 bg-white border border-gray-200 rounded-md text-gray-900">
                    {formatDate(cert.issue_date)}
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Tanggal Expired
                  </label>
                  <div className="px-3 py-2 bg-white border border-gray-200 rounded-md text-gray-900">
                    {formatDate(cert.expiry_date)}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
